import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    if (this.props.onError) {
        this.props.onError(error, errorInfo);
    }
  }

  public render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      const fallbackMessage = this.props.fallback || 
        `Something went wrong rendering this component. Error: ${this.state.error?.message || 'Unknown error'}`;
      // Render fallback in a way that doesn't break layout too much
      return typeof fallbackMessage === 'string' ? <div>{fallbackMessage}</div> : fallbackMessage;
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 